import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { useFixedColumns } from './hooks/useFixedColumns';
import { useGetTravelMovementsExport } from 'queries';
import TravelMovementsExportForm from './components/TravelMovementsExportForm';

const TravelMovementsExport = () => {
  const columns = useFixedColumns();
  const { data, isFetching } = useGetTravelMovementsExport();

  return (
    <TableCRUDLayout
      FormComponent={TravelMovementsExportForm}
      rows={data}
      loading={isFetching}
      columns={columns}
      getRowId={(row) => row.id}
      hideCreateAction
      shouldRenderToolBar={false}
    />
  );
};

export default TravelMovementsExport;
